import React from "react";
import { useSync } from "../context/SyncContext";
import { CloudCheck, CloudSlash, ArrowsClockwise, WifiSlash } from "@phosphor-icons/react";

export default function SyncBadge() {
  const { online, syncing, pending } = useSync();

  let label, cls, Icon;
  if (!online) {
    label = "Offline";
    cls = "bg-offline text-white";
    Icon = WifiSlash;
  } else if (syncing) {
    label = "Syncing…";
    cls = "bg-teal text-white";
    Icon = ArrowsClockwise;
  } else if (pending > 0) {
    label = `${pending} to sync`;
    cls = "bg-warning text-white";
    Icon = CloudSlash;
  } else {
    label = "Synced";
    cls = "bg-success text-white";
    Icon = CloudCheck;
  }

  return (
    <div
      data-testid="sync-badge"
      className={`inline-flex items-center gap-1.5 px-3 h-9 rounded-full text-sm font-head font-semibold ${cls}`}
    >
      <Icon size={18} weight="bold" className={syncing ? "animate-spin" : ""} />
      <span>{label}</span>
    </div>
  );
}
